<template>
  <div class="container">
    <main class="section-card privacy-policy-card">
      <h1 class="hero-title">
        <span class="highlight">Политика конфиденциальности</span>
        <span class="title-divider"></span>
      </h1>
      <p class="publication-date">Дата публикации: 25 августа 2025 года</p>
      <p class="publication-date">Начало действия: с 25 августа 2025 года</p>

      <section class="policy-section">
        <h2 class="section-title">1. Общие положения</h2>
        <p class="body-text">
          1.1. Настоящая Политика является официальным документом Общества с ограниченной ответственностью “ТомоВеб
          Решения” (ОГРН 1247700717032, ИНН 9729388155) (Далее – Администратор Сайта) и определяет порядок сбора,
          записи, систематизации, накопления, хранения, уточнения (обновления, изменения), извлечения, использования,
          передачи, распространения, предоставления, обезличивания, блокирования, удаления, уничтожения и защиты
          персональных данных, с использованием средств автоматизации, а также без использования таких средств (Далее –
          Обработка) физических лиц (Далее – Пользователи), а также определяет условия и порядок получения
          соглашений/разрешений на использование произведений (части произведений, аннотаций, тезисов/цитат из
          произведений) Пользователей (авторские права) (Далее – Авторское согласие), при использовании Пользователями
          услуг, условий, предоставляемых Администратор Сайта на интернет-сайте
          <a href="https://ct-map.ru" target="_blank" rel="noopener">https://ct-map.ru</a> (Далее – Сайт), его сервисов и
          действует в отношении всей информации, которую Администратор Сайта может получить о Пользователе во время
          использования Сайта и сервисов Сайта.
        </p>
        <p class="body-text">
          1.2. Политика устанавливает обязательства Администратора Сайта по неразглашению и обеспечению режима защиты
          конфиденциальности, Обработки персональных данных, формированию условий по использованию произведений (части
          произведений, аннотаций, тезисов/цитат из произведений) Пользователей (авторские права), предоставляемые
          Пользователем Администратору Сайта.
        </p>
        <p class="body-text">
          1.3. При Обработке персональных данных и получения Авторского согласия у Пользователя младше 18 лет, данный
          Пользователь обязаны предоставить соответствующие согласие своих законных представителей (в форме, требуемой
          нормам действующего законодательства Российской Федерации). В отсутствии вышеуказанных согласий законных
          представителей в требуемой форме (и/или в случае выявления предоставление Пользователем недостоверной
          информации о своем возврате), Администратор Сайта будет вынужден отказать Пользователю в предоставлении услуг
          Сайта, Мероприятия Сайта.
        </p>
        <p class="body-text">
          1.4. Настоящая Политика применяется только к Сайту. Администратор Сайта не контролирует и не несет
          ответственность за сайты третьих лиц, сторонних организаций, на которые Пользователь может перейти по ссылкам,
          доступным на Сайте.
        </p>
        <p class="body-text">
          1.5. Отношения, указанные в настоящей Политики, регулируются официальными документами Администратора Сайта и
          действующим законодательством Российской Федерации.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="section-title">2. Действие документа</h2>
        <p class="body-text">
          2.1. Действующая редакция Политики является публичным документом и доступна любому пользователю сети Интернет
          при переходе по ссылке, ведущий маршрутом на адрес Сайта.
        </p>
        <p class="body-text">
          2.2. Начиная использовать Сайт, в том числе его отдельные функции (включая, но не ограничиваясь: пройдя
          процедуру регистрации, процедуру подачи краткой аннотации) Пользователь считается принявшим условия настоящего
          документа в полном объеме, без всяких оговорок и исключений (выполнения одного из способов акцепта, без
          оговорок и исключений (“click-wrap agreement”, “browsewrap agreement”), отвечающие в полной мере требованиям
          действующего законодательства Российской Федерации (выражение воли на совершение сделки в конклюдентном виде,
          в электронной форме)): использование Сайта означает безоговорочное согласие Пользователя с настоящей
          Политикой, указанными в ней условиями Обработки персональных данных, Авторского согласия. В случае несогласия с
          условиями настоящей Политики, Пользователь обязан незамедлительно прекратить использование Сайта или отозвать
          свою регистрацию, заявку на подачи краткой аннотации, на условиях указанной в настоящем документе.
        </p>
        <p class="body-text">
          2.3. Администратор Сайта вправе вносить изменения в настоящую Политику без согласия Пользователя и без его
          уведомления. Новая редакция Политики вступает в силу с момента ее размещения на Сайте, если иное не
          предусмотрено новой редакцией Политики. Пользователь должен самостоятельно отслеживать внесение
          изменений/дополнений в Политику. В случае несогласия с любыми вышеуказанными изменениями/дополнениями,
          Пользователь обязан незамедлительно прекратить использование Сайта и совершить процедуру отзыва поданных
          согласий/разрешений.
        </p>
        <p class="body-text">
          2.4. Если в соответствии с действующим законодательством Российской Федерации требуется получение отдельного
          согласия Пользователя на Обработку персональных данных, получения Авторского согласия, в связи с
          использованием Сайта, Администратор Сайта обязан его получить от Пользователя. Вышеуказанное отдельное
          согласие может быть получено как путем подписания на бумажном носителе, так и получено в электронном виде (в
          том числе в PDF формате (Portable Document Format), скан-копии) посредствам направления Пользователя
          подписанного согласия со своего адреса электронной почты, указанного при соответствующей процедуре регистрации
          на Сайте, процедуре подачи краткой аннотации. Администратор Сайта и Пользователь презюмируют, что именно
          Пользователь, с чьего адреса электронной почты направлено соответствующее надлежащим образом подписанное
          согласие - данное согласие и направил. Пользователь и Администратор Сайта подтверждает, что в данном случае
          идентификатором Пользователя выступает адрес электронной почты Пользователя.
        </p>
        <p class="body-text">
          2.5. Администратор Сайта не проверяет достоверность персональных данных, авторства произведений Пользователей
          и иной информации, предоставляемой Пользователями.
        </p>
        <p class="body-text">
          2.6. Пользователь дает согласие на Обработку его персональных данных и Авторское согласие на весь срок,
          необходимый Администратору Сайта для достижения целей Обработки, Авторского согласия, в том числе на весь срок
          проведения Мероприятия Сайта.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="section-title">3. Объем персональных данных</h2>
        <p class="body-text">
          3.1. Администратор Сайта осуществляет Обработку следующих видов персональных данных о Пользователях Сайта,
          самостоятельно вносимые/предоставляемые Пользователями Администратору Сайта:
        </p>
        <ol class="policy-list alpha-list">
          <li>Фамилия, имя, отчество</li>
          <li>Гражданство</li>
          <li>Контактный номер телефона</li>
          <li>Адрес электронной почты</li>
          <li>Место проживания</li>
          <li>Место работы/учебы</li>
          <li>Занимаемая должность/курс</li>
          <li>Ученая степень/звание</li>
          <li>
            Биометрические персональные данные Пользователя (при участии в Мероприятии Сайта):
            <ul>
              <li>изображение Пользователя на фотографии и видеозаписи</li>
              <li>звук голоса Пользователя на аудиозаписи, видеозаписи</li>
              <li>видеоматериалы, фотоматериалы, аудиозаписи, аудиовизуальные произведения с Пользователем</li>
            </ul>
          </li>
          <li>
            Данные технического характера об устройстве и интернет-подключении: автоматический сбор (из текстовых файлов
            “Cookies”) следующих обезличенных статистических данных о Пользователе Сайта, в том числе:
            <ul>
              <li>тип выполненного на Сайте действия (клик, наведение курсора и т.п.)</li>
              <li>дата и время выполнения действия</li>
              <li>URL страницы</li>
              <li>Refer</li>
              <li>последнее посещение и активность</li>
              <li>Flash-куки</li>
              <li>история посещений</li>
              <li>IP (без возможности работы с IP-адресами в статистике)</li>
              <li>User-Agent</li>
              <li>ClientID (идентификатор браузера по файлу Cookie)</li>
              <li>экранное разрешение</li>
              <li>тип устройства Пользователя</li>
              <li>местоположение Пользователя</li>
              <li>язык Пользователя</li>
              <li>класс HTML-элемента, на который происходит клик</li>
              <li>данные о фактах заполнения форм на Сайте, включая ошибки при их заполнении</li>
            </ul>
          </li>
          <li>Паспортные данные</li>
        </ol>
        <p class="body-text">
          3.1.1. Под термином “Пользователь” определены следующие лица: (а) физическое лицо, регистрирующиеся на Сайте
          для использования Сайта и его возможностями, (б) любое физическое лицо, зашедшее на Сайт, но не
          зарегистрированное на Сайте для использования всех возможностей Сайта.
        </p>
        <p class="body-text">
          3.2. В отношении персональных данных Пользователя сохраняется их конфиденциальность, кроме случаев
          добровольного предоставления Пользователем информации о себе для общего доступа неограниченному кругу лиц. При
          использовании отдельных функциональных возможностей Сайта Пользователь соглашается с тем, что определенная
          часть его персональной информации становится общедоступной.
        </p>

        <p class="body-text">
          3.3. Администратор Сайта вправе передать персональные данные Пользователя третьим лицам в следующих случаях:
        </p>
        <ul class="policy-list">
          <li>3.3.1. Пользователь выразил согласие на такие действия.</li>
          <li>
            3.3.2. Передача необходима для исполнения определенного соглашения, договора и иного юридически-значимого
            документа с Пользователем.
          </li>
          <li>
            3.3.3. Установление коммуникации с Пользователем (по указанным Пользователям каналам связи на Сайте) для
            подтверждения его волеизъявления по вопросу посещения Сайта.
          </li>
          <li>
            3.3.4. Передача предусмотрена российским или иным применимым законодательством в рамках установленной
            законодательством процедуры.
          </li>
        </ul>

        <p class="body-text">
          3.4. Обработка персональных данных Пользователя осуществляется до момента отзыва Пользователя согласия на
          Обработку персональных данных, либо до истечения сроков Обработки, установленных законодательством. В случае
          необходимости Пользователю осуществить отзыв согласия на Обработку персональных данных, Пользователь может
          совершить данное действие, направив на контактный адрес электронной почты Администратора Сайта (указан на
          Сайте и в настоящем документе) соответствующее уведомление с обязательной пометкой “Отзыв персональных
          данных”.
        </p>
        <p class="body-text">
          3.5. При утрате или разглашении персональных данных Администратор Сайта информирует Пользователя об утрате или
          разглашении персональных данных и выполняет иные требования, установленные законодательством в связи с
          наступлением такого события.
        </p>
        <p class="body-text">
          3.6. Администратор Сайта принимает необходимые организационные и технические меры для защиты персональных
          данных Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования,
          копирования, распространения, а также от иных неправомерных действий третьих лиц.
        </p>
        <p class="body-text">
          3.7. Администратор Сайта совместно с Пользователем принимает все необходимые меры по предотвращению убытков или
          иных отрицательных последствий, вызванных утратой или разглашением персональных данных Пользователя.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="section-title">4. Цели Обработки персональных данных Пользователя</h2>
        <p class="body-text">
          4.1. Администратор Сайта Обрабатывает только ту персональную информацию, которая необходима для использования
          Пользователем Сайта, сервисов Сайта, за исключением случаев, когда законодательством предусмотрено обязательное
          хранение персональной информации в течение определенного законом срока.
        </p>
        <p class="body-text">
          4.2. Перечень действий, осуществляемых Администратором Сайта с персональными данными Пользователей: указан в
          п.1.1. настоящего документа и является описанием термина “Обработка”.
        </p>

        <p class="body-text">
          4.3. Персональные данные Пользователя Администратор Сайта вправе использовать в следующих целях:
        </p>
        <ul class="policy-list">
          <li>4.3.1. Предоставления Пользователям доступа к Сайту, к информации на Сайте.</li>
          <li>4.3.2. Установление коммуникации с Пользователем.</li>
          <li>4.3.3. Обеспечение безопасности Сайта.</li>
          <li>
            4.3.4. Установление и поддержание связи между Пользователем и Администратором Сайта, включая направление
            уведомлений, запросов, касающихся использования Сайта, оказания услуг, обработки запросов, заявок,
            обращений, жалоб, претензий от Пользователя, консультирование по вопросам Сайта, Авторского согласия,
            возможности приобретения статуса “Партнер”, уведомление о состоянии и исполнении запросов Пользователя.
          </li>
          <li>
            4.3.5. Направление Пользователю сообщений рекламного, информационного характера, таргетирование рекламных
            материалов. Направление сообщений информационного, рекламного характера может осуществляться, как
            Администратором Сайта, так и третьими лицами, которые принимают участие в оказании услуг, работы в рамках
            реализации условий Авторского согласия. Сообщения информационного, рекламного характера могут направляться
            на адрес электронной почты и номер мобильного телефона Пользователя, (в том числе посредствам
            Push-уведомлений (короткие сообщения)).
          </li>
          <li>
            4.3.6. Размещение в официальных группах социальных сетей и иных сообществах Администратора Сайта в сети
            Интернет, в прочих рекламных, информационных источниках Сайта.
          </li>
          <li>
            4.3.7. Осуществления работ по улучшению качества услуг, работ Администратора Сайта, по повышению удобства
            использования Сайта, а также разработки новых возможностей Сайта.
          </li>
          <li>
            4.3.8. Проведения статистических исследований на основе обезличенных сведений, предоставленных
            Пользователями, анализа полученных статистических данных, анализа результатов использования Сайта.
          </li>
          <li>
            4.3.9. Предоставление Пользователю об обновлении услуг, специальных предложений, информационных, новостных
            рассылок и иных сведений.
          </li>
          <li>
            4.3.10. Предоставления Пользователю эффективной клиентской и технической поддержки при возникновении проблем,
            связанных с использованием Сайта.
          </li>
          <li>4.3.11. Защиты от мошенничества и злоупотреблений.</li>
          <li>4.3.12. Соблюдения действующего законодательства Российской Федерации.</li>
        </ul>

        <p class="body-text">
          4.4. Пользователь настоящим уведомлен и соглашается, что при использовании Сайта может получать данные об
          установленных на мобильном устройстве Пользователя приложениях, и использовать их для реализации отдельных
          функций, возможностей Сайта.
        </p>
        <p class="body-text">
          4.5. Пользователь настоящим уведомлен и соглашается, что Администратор Сайта может получать статистические
          обезличенные (без привязки к Пользователю) данные о действиях Пользователя при использовании Сайта и об
          установленных Пользователем настройках Сайта.
        </p>
      </section>

      <section class="policy-section">
        <h2 class="section-title">5. Обязанности сторон</h2>

        <p class="body-text">5.1. Пользователь обязан:</p>
        <ul class="policy-list">
          <li>
            5.1.1. Предоставить достоверную информацию о персональных данных, об авторских правах и иных гарантий,
            указанных в настоящем документе, необходимая для пользования Сайтом, а также для иных целей, указанных в
            настоящей Политике.
          </li>
          <li>
            5.1.2. Обновлять, дополнять предоставленную информацию о персональных данных, данных, указанных в Авторском
            согласии, в случае изменения данной информации. В случае выявления неточностей/недостоверностей в
            представленных Пользователям данных, Пользователь может актуализировать/дополнить/изменить их, направив на
            контактный адрес электронной почты Администратора Сайта (указан на Сайте) соответствующее уведомление с
            обязательной пометкой “Актуализация персональных данных”.
          </li>
          <li>5.1.3. Надлежащим образом соблюдать условия и требования, отраженные в настоящем документе.</li>
        </ul>

        <p class="body-text">5.2. Администратор Сайта обязан:</p>
        <ul class="policy-list">
          <li>
            5.2.1. Не использовать данные способами, порочащими честь, достоинство и деловую репутацию Пользователя.
          </li>
          <li>
            5.2.2. Обрабатывать персональные данные Пользователей исключительно для целей, указанных в настоящей
            Политике.
          </li>
          <li>5.2.3. Использовать представленные Объекты, в рамках данного Пользователем Авторским согласием.</li>
          <li>
            5.2.4. Принимать меры предосторожности для защиты данных Пользователя согласно порядку, обычно используемому
            для защиты такого рода информации в существующем деловом обороте.
          </li>
          <li>
            5.2.5. Соблюдать нормы авторского права, интеллектуальной собственности в отношении Объектов Пользователя.
          </li>
        </ul>
      </section>

      <section class="policy-section">
        <h2 class="section-title">6. Отзыв согласий/разрешений</h2>
        <p class="body-text">
          6.1. Отзыв соглашений/разрешений, указанных в настоящем документе, осуществляется путем подачи письменного
          заявления в адрес Администратора Сайта:
          <a class="mail-link" href="mailto:tomowebsolutions@yandex.ru">tomowebsolutions@yandex.ru</a>. В заявлении
          необходимо указать фамилию, имя, отчество Пользователя, серию, номер основного документа, удостоверяющего
          личность, сведения о дате выдачи указанного документа и выдавшем его органе, перечень персональных
          данных/Объекта.
        </p>
        <p class="body-text">
          6.2. Администратор Сайта рассматривает вышеуказанные отзывы в следующий срок: 20 (двадцать) рабочих дней со
          дня поступления соответствующего заявления от Пользователя на вышеуказанный адрес электронной почты
          Администратора Сайта.
        </p>
        <p class="body-text">
          6.3. В случае, если отзыв персональных данных Пользователя и Авторского согласия повлечет за собой нанесения
          убытков, как Администратору Сайта, так и третьим лицам, Администратор Сайта имеет право взыскать все возникшие
          убытки (в том числе выстеленные третьими лицами в адрес Администратора Сайта) и компенсировать все затраты,
          появившиеся в результате такого отзыва, включая расходы на обработку претензий, судебные издержки, оплату
          услуг представителей и иные расходы, непосредственно связанные с устранением последствий действий
          Пользователя.
        </p>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'PrivacyView',
};
</script>

<style scoped>
/* ========== 🏗️ ОСНОВНЫЕ СТИЛИ 🏗️ ========== */
.container {
  max-width: 850px;
  margin: 32px auto;
  padding: 16px;
}

.section-card {
  padding: 32px;
  border-radius: 16px;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* ========== 🖋️ ТИПОГРАФИКА 🖋️ ========== */
.hero-title {
  font-size: 28px;
  margin: 0 0 24px;
  color: var(--text-primary);
  font-weight: 700;
  text-align: left;
}

.hero-title .highlight {
  color: var(--accent);
}

.title-divider {
  display: block;
  width: 100px;
  height: 3px;
  margin-top: 12px;
  background: linear-gradient(90deg, var(--accent) 0%, transparent 100%);
  border-radius: 2px;
}

.publication-date {
  color: var(--text-muted);
  font-style: italic;
  margin-bottom: 8px;
  text-align: left;
  font-size: 15px;
}

.body-text {
  color: var(--text-primary);
  font-size: 16px;
  line-height: 1.8;
  font-weight: 400;
  text-align: left;
  margin-bottom: 16px;
}

/* ========== 📐 СТРУКТУРА СЕКЦИЙ 📐 ========== */
.policy-section {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid var(--border-color);
}

.policy-section:first-of-type {
  margin-top: 24px;
  border-top: none;
  padding-top: 0;
}

.section-title {
  font-size: 22px;
  color: var(--text-primary);
  font-weight: 600;
  margin-bottom: 16px;
}

/* ========== 📋 СПИСКИ 📋 ========== */
.policy-list {
  margin: 16px 0 16px 20px;
  padding-left: 0;
  color: var(--text-primary);
}

.policy-list li {
  margin-bottom: 12px;
  line-height: 1.7;
  padding-left: 10px;
}

.policy-list ul {
  margin-top: 12px;
  padding-left: 25px;
  list-style-type: disc;
}

.alpha-list {
  list-style-type: upper-roman;
}

/* ========== 📞 ССЫЛКИ 📞 ========== */
a {
  color: var(--accent);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

a:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
  text-shadow: 0 0 10px var(--accent-glow);
}

/* ========== 📱 АДАПТИВНОСТЬ 📱 ========== */
@media (max-width: 768px) {
  .hero-title {
    text-align: center;
  }
  .title-divider {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 576px) {
  .container {
    margin: 16px auto;
    padding: 8px;
  }
  .section-card {
    padding: 24px;
  }
  .hero-title {
    font-size: 24px;
  }
  .body-text {
    font-size: 15px;
  }
}
</style>